import React from "react";
import { motion } from "framer-motion";
import HomeButton from "../common/HomeButton";
import "./about.css";

export default function About(){

    return(
        <div>
        <HomeButton/>
        <motion.div 
            id="About"
            // initial={{opacity: 0.2, scale: 0.3}}
            // animate={{opacity: 1, scale: 1}}
            // transition={{duration: .75}}
        >
            <div className="scroll" id="main">
                <motion.div
                    initial={{opacity: 0.2, scale: 0.3}}
                    animate={{opacity: 1, scale: 1}}
                    transition={{duration: .5}}
                >
                    <h2>a little about me</h2>
                    <div>
                        <p>Hello there! I am 26 year old Denasia. I was born and mostly raised in Mississippi. I've moved around a lot but now I am back on the coast. I adore everything Star Wars and Japan and I finally got to fulfill my dream of visiting! I love to rollerskate, crochet, and spend time with family and friends. I absolutely love music. I was a band kid growing up, I played the clarinet, taught myself to play the flute and dabbled in other instruments and then color guard. I love languages. I'm fluent in ASL and I'm currently learning Japanese and Spanish. Needless to say, I love learning new things, developing skills, and putting my brain to work!
                        </p>
                    </div>
                </motion.div>

                <motion.div
                    initial={{opacity: 0, scale: 0.3, y: -200}}
                    animate={{opacity: 1, scale: 1, y: 0}}
                    transition={{duration: .5, delay: .1}}
                >
                <h2>my journey into tech</h2>
                <div>
                    <p>I've always been a tech-savy person so it wasn't surprising that I wanted to learn how to code. I've always wanted to know how things worked, what's ticking on the inside. I spent my high school career heavily involved in robotics and STEM classes. Though that's not what I pursued after high school, I kept my love of coding and web development as a hobby. Fast forward, I started taking software development seriously when I chose to quit my job as an ASL interpreter. I enrolled in a fulltime 6 month software engineering bootcamp. I wanted to learn as much as I could as fast as I could to kick start my career switching journey. I loved it! I learned a lot and gained practical experience from working with my team. The end of my programm lined up with a huge wave of layoffs in the industry so the job search didn't go as planned; chaotic, overwhelming, and disappointing. Time moved on, I never did land a job as a software engineer. That, however, didn't mean I was giving up! Today I am still actively involved in tech and hope to career switch very soon!
                    </p>
                </div>
                </motion.div>

                <motion.div
                    initial={{opacity: 0, scale: 0.3, y: -300}}
                    animate={{opacity: 1, scale: 1, y: 0}}
                    transition={{duration: .5, delay: .2}}
                >
                <h2>education</h2>
                <div>
                    <p>I obtained an Associates degree from Mississippi Gulf Coast Community College in Interpreting Training Technology, leading me to a year long career as an ASL interpreter. I also completed Thinkful's Software Engineering immersion course in 2022. I'm currently pursuing a Bachelor's in Computer Science at Western Governers University and am determined to gain more certifications along the way.
                    </p>
                </div> 
                </motion.div>
            </div>
        </motion.div>
        </div>
    )
};